import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromWishlist } from '../store/wishlistSlice';
import { addToCart } from '../store/cartSlice';
import { FiHeart, FiTrash2, FiShoppingBag } from 'react-icons/fi';
import { toast } from 'react-toastify';
import './Wishlist.css';

export default function Wishlist() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const items = useSelector(s => s.wishlist.items);

  const handleMoveToCart = (item) => {
    dispatch(addToCart({ ...item, quantity: 1, selectedSize: item.sizes?.[0] || 'M' }));
    dispatch(removeFromWishlist(item.id));
    toast.success('Moved to bag!');
  };

  const handleRemove = (id) => {
    dispatch(removeFromWishlist(id));
    toast.info('Removed from wishlist');
  };

  if (items.length === 0) return (
    <div className="wishlist-empty-page">
      <div className="wishlist-empty">
        <FiHeart className="wishlist-empty-icon" />
        <h2>Your Wishlist is empty!</h2>
        <p>Save items that you like in your wishlist. Review them anytime and move them to bag.</p>
        <Link to="/products" className="btn btn-primary btn-lg">Continue Shopping</Link>
      </div>
    </div>
  );

  return (
    <div className="wishlist-page">
      <div className="wishlist-header">
        <h1>My Wishlist <span>({items.length} Items)</span></h1>
      </div>
      <div className="wishlist-grid">
        {items.map(item => {
          const discount = item.originalPrice
            ? Math.round((1 - item.price / item.originalPrice) * 100) : 0;
          return (
            <div key={item.id} className="wl-card">
              <div className="wl-image" onClick={() => navigate(`/product/${item.id}`)}>
                <span className="wl-emoji">{item.imageEmoji || '👗'}</span>
                {item.imageUrl && <img src={item.imageUrl} alt={item.name} />}
                {discount > 0 && <span className="wl-badge">{discount}% OFF</span>}
                <button className="wl-remove-btn" onClick={e => { e.stopPropagation(); handleRemove(item.id); }}>
                  <FiTrash2 />
                </button>
              </div>
              <div className="wl-info">
                <p className="wl-brand">{item.brand}</p>
                <p className="wl-name">{item.name}</p>
                <div className="wl-price-row">
                  <span className="wl-price">₹{item.price?.toLocaleString()}</span>
                  {item.originalPrice && <span className="wl-original">₹{item.originalPrice?.toLocaleString()}</span>}
                  {discount > 0 && <span className="wl-off">({discount}% off)</span>}
                </div>
                {item.rating && (
                  <div className="wl-rating">⭐ {item.rating} ({item.reviewCount})</div>
                )}
                <button className="wl-move-btn" onClick={() => handleMoveToCart(item)}>
                  <FiShoppingBag /> Move to Bag
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
